<template>
    <el-container>
        <el-header>
          <div class="logodiv" style="height: 95px"><img alt="" src="static/relixue.jpg" width="100%"></div> <div class="regdiv"><span class="logout" @click="onLogout"><i class="el-icon-unlock"></i> 注销[实验老师]</span></div>
        </el-header>
        <el-main>
          <div class="cardrow">
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
              <el-menu-item index="1"><router-link to="/relixue/index" style="text-decoration: none;">实验首页</router-link></el-menu-item>
              <el-menu-item index="2">仿真实验</el-menu-item>
              <el-menu-item index="3"><router-link to="/relixue/upgrade" style="text-decoration: none;">下载升级</router-link></el-menu-item>
              <el-menu-item index="4"><router-link to="/relixue/teach" style="text-decoration: none;">教学情况</router-link></el-menu-item>
              <el-menu-item index="5"><router-link to="/relixue/person" style="text-decoration: none;">用户中心</router-link></el-menu-item>
            </el-menu>
          </div>
          <div><img alt="" src="static/xlabbanner.jpg"></div>
          <div class="cardrow" style="text-align: left;">
            <span><el-tag effect="dark">模块一: 测量喷管流量虚拟仿真实验</el-tag></span>
            <el-divider content-position="right">SIMULATION EXPERIMENT</el-divider>
            <el-row>
              <el-col :span="4">
                <el-menu
                  default-active="1"
                  class="el-menu-vertical-demo"
                  @select="handleOpen"
                  @close="handleClose">
                  <el-menu-item index="1">
                      <i class="el-icon-s-flag"></i>
                      <span>实验背景</span>
                  </el-menu-item>
                  <el-menu-item index="2">
                    <i class="el-icon-menu"></i>
                    <span slot="title">实验目的</span>
                  </el-menu-item>
                  <el-menu-item index="3">
                    <i class="el-icon-s-opportunity"></i>
                    <span slot="title">实验原理</span>
                  </el-menu-item>
                  <el-menu-item index="4">
                    <i class="el-icon-video-camera-solid"></i>
                    <span slot="title">实验过程</span>
                  </el-menu-item>
                  <el-menu-item index="5">
                    <i class="el-icon-setting"></i>
                    <span slot="title">实验方法</span>
                  </el-menu-item>
                  <el-menu-item index="6">
                    <i class="el-icon-s-unfold"></i>
                    <span slot="title">实验步骤</span>
                  </el-menu-item>
                  <el-menu-item index="7">
                    <i class="el-icon-message-solid"></i>
                    <span slot="title">开始实验</span>
                  </el-menu-item>
                  <el-menu-item index="8">
                    <i class="el-icon-s-claim"></i>
                    <span slot="title">考核要求</span>
                  </el-menu-item>
                </el-menu>
              </el-col>
              <el-col :span="20">
                <div v-if="menuIdx === '1'" style="text-align: center; margin-top: 20px;"><img alt="" src="static/emb01_p1.jpg" width="600px"></div>
                <div v-if="menuIdx === '2'" style="text-align: center; margin-top: 20px;"><img alt="" src="static/emb01_p2.jpg" width="600px"></div>
                <div v-if="menuIdx === '3'" style="text-align: center; margin-top: 20px;"><img alt="" src="static/emb01_p3.jpg" width="600px"></div>
                <div v-if="menuIdx === '4'" style="text-align: center; margin-top: 20px;"><img alt="" src="static/emb01_p4.jpg" width="600px"></div>
                <div v-if="menuIdx === '5'" style="text-align: center; margin-top: 20px;"><img alt="" src="static/emb01_p5.jpg" width="600px"></div>
                <div v-if="menuIdx === '6'" style="text-align: center; margin-top: 20px;"><img alt="" src="static/emb01_p6.jpg" width="600px"></div>
                <div v-if="menuIdx === '7'" style="text-align: center; margin-top: 20px;">

                    <span style="color: #F56C6C"><i class="el-icon-warning"></i> 点击下方开始按钮进入实验，实验完毕后请确保提交了实验记录并出现如下实验报告界面。</span>
                    <img alt="" src="static/emb01_p7.jpg" width="600px">
                    <div>
                     <el-button type="primary" plain style="width: 300px;" @click="startlab"><span style="font-size: 50px">开始实验</span></el-button>
                    </div>
                </div>
                <div v-if="menuIdx === '8'" style="text-align: center; margin-top: 20px;"><img alt="" src="static/emb01_p8.jpg" width="600px"></div>
              </el-col>
            </el-row>
          </div>
        </el-main>
        <el-footer>
          <el-divider></el-divider>
          系统集成与技术支持：湖南湘交高创信息技术有限公司 
          <el-rate
            v-model="rate"
            disabled
            show-score
            text-color="#ff9900"
            score-template="{value}">
          </el-rate>
        </el-footer>
    </el-container>
</template>


<script>
export default {
  data () {
    return {
      activeIndex: '2',
      currentDate: new Date(),
      rate: 3.9,
      menuIdx: '1'
    }
  },
  beforeMount:function(){
    if (!sessionStorage.getItem('user')){
      this.$router.push({path: "/relixue/login"});
    }
  },
  mounted:function(){
      
  },
  methods: {
    onLogout() {
      this.$confirm('注销将清空实验操作空间, 操作结果是否已上传?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          sessionStorage.removeItem("checked");
          this.$router.push({path: "/"});
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
      
    },
    handleSelect() {

    },
    handleClick(e) {
      if (e === 0 || e === 2 || e === 3){
        this.$message.error('临时空间不足');
      }else{
        this.$message({
          message: '该步骤无下载项',
          type: 'success'
        });
      }
    },
    handleOpen(index, indexPath) {
      this.menuIdx = index;
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    startlab() {
      const loading = this.$loading({
          lock: true,
          text: '启动实验客户端..',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        window.location.href = 'iotelab://83026EECB5E97E0241F070C6219AD3C4';
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .el-header {
    /* background-color: #B3C0D1; */
    color: #333;
    text-align: center;
    line-height: 95px;
    height: 95px !important; 
  }

  .el-footer {
    text-align: center;
    line-height: 35px;
  }
  
  .el-main {
    /* background-color: #0068B7; */
    /* color: #333; */
    text-align: center;
    /* line-height: 160px; */
    width: 100%;
    /* height: 50vh; */
    padding: 0;
    overflow: hidden;
  }

  .logodiv {
    float: left;
    margin-left: 10%;
  }

  .regdiv {
    float: right;
    margin-right: 10%;
  }

  .logout {
    color: #0068B7;
  }

  .logout:hover {
    cursor: pointer;
  }

  .cardrow {
    width: 60%;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/ReLiXue/LabEMB01.vue